<div class="session-form-container">

  <div [hidden]="!loading" class="spinner">
    <div class="sk-spinner sk-spinner-pulse"></div>
  </div>
  <ul class="nav nav-pills mb-3 tabs" id="pills-tab22" role="tablist">
    <li class="nav-item" role="presentation">
      <button class="nav-link active" id="general-tab" data-bs-toggle="pill" data-bs-target="#pills-general" type="button" role="tab"
        aria-controls="pills-general" aria-selected="true">General</button>
    </li>
    <li class="nav-item" role="presentation">
      <button class="nav-link" id="advance-tab" data-bs-toggle="pill" data-bs-target="#pills-advance" type="button" role="tab" aria-controls="pills-advance"
        aria-selected="false">Advanced options</button>
    </li>
  </ul>

  <form [formGroup]="form" (ngSubmit)="onSubmit()">
    <div class="tab-content setting-content" id="pills-tabContent">
      <div class="tab-pane fade show active" id="pills-general" role="tabpanel" aria-labelledby="general-tab">
        <h4 class="my-15">Enter your SMPP session details</h4>
        <div class="d-flex gap-10 mb-15">
          <div class="w-100">
            <label for="login" class="form-label required">Login </label>
            <span class="icon icon-help-1 text-neutral-n6 ms-10" tooltip="Mandatory SMPP parameter <b>system_id</b> that identifies the SMPP session."> </span>
            <input [(ngModel)]="model.systemId" formControlName="systemId" type="text" class="form-control" required />
            <input-errors [control]="form.controls.systemId" [service]="validationService"></input-errors>
          </div>
          <div class="w-100">
            <label for="password" class="form-label required">Password </label>
            <input autocomplete="new-password" [(ngModel)]="model.password" formControlName="password" type="password" class="form-control" />
            <input-errors [control]="form.controls.password" [service]="validationService"></input-errors>
          </div>
        </div>
        <div class="d-flex gap-10 mb-15">
          <div class="w-100">
            <label for="host" class="form-label required">Host </label>
            <input autocomplete="new-password" [(ngModel)]="model.hostIp" formControlName="hostIp" type="text" class="form-control" />
            <input-errors [control]="form.controls.hostIp" [service]="validationService"></input-errors>
          </div>
          <div class="w-100">
            <label for="port" class="form-label required">Port </label>
            <input [(ngModel)]="model.hostPort" formControlName="hostPort" type="number" class="form-control" />
            <input-errors [control]="form.controls.hostPort" [service]="validationService"></input-errors>
          </div>
        </div>

        <div class="d-flex gap-10 mb-15">
          <div class="w-100">
            <label for="systemType" class="form-label">System type </label>
            <span class="icon icon-help-1 text-neutral-n6 ms-10"
              tooltip="Optional SMPP parameter <b>system_type</b> that is used to identify the type of the ESME system requesting to bind with the SMSC (host SMPP server).">
            </span>
            <input [(ngModel)]="model.systemType" formControlName="systemType" type="text" class="form-control" />
            <input-errors [control]="form.controls.systemType" [service]="validationService"></input-errors>
          </div>
          <div class="w-100">
            <label for="throughput" class="form-label required">Throughput (SMS/second) </label>
            <span class="icon icon-help-1 text-neutral-n6 ms-10"
              tooltip="The max. amount of SMS that will be submitted per second from our platform to the SMSC (host SMPP server). <br> If more SMS are being created (at once) than the value specified here, they will be submitted in multiple batches, in order not to exceed this limit.<br><br> Note: Real max possible number depends on the remote SMSC latency, and if windowing is enabled (parallel submits). This value is not a guarantee of throughput, just the max allowed.">
            </span>
            <input [(ngModel)]="model.throughput" formControlName="throughput" type="number" class="form-control" />
            <input-errors [control]="form.controls.throughput" [service]="validationService"></input-errors>
          </div>
        </div>

        <div class="d-flex gap-10 mb-15">
          <div class="w-100">
            <label for="Destination TON" class="form-label required">Destination TON </label>
            <span class="icon icon-help-1 text-neutral-n6 ms-10" tooltip="Mandatory SMPP parameter <b>dest_addr_ton</b> set to 1 by default."> </span>
            <div class="d-flex gap-25">
              <div *ngFor="let item of tonItems">
                <input [(ngModel)]="model.dstTon" formControlName="dstTon" [value]="item.id" class="form-check-input me-10" type="radio" />
                <label class="form-check-label"> {{ item.text }} </label>
                <input-errors [control]="form.controls.dstTon" [service]="validationService"></input-errors>
              </div>
            </div>
          </div>
          <div class="w-100">
            <label for="Destination NPI" class="form-label required">Destination NPI </label>
            <span class="icon icon-help-1 text-neutral-n6 ms-10" tooltip="Mandatory SMPP parameter <b>dest_addr_npi</b> set to 1 by default."> </span>
            <div class="d-flex gap-25">
              <div *ngFor="let item of npiItems">
                <input [(ngModel)]="model.dstNpi" formControlName="dstNpi" [value]="item.id" class="form-check-input me-10" type="radio" />
                <label class="form-check-label"> {{ item.text }} </label>
                <input-errors [control]="form.controls.dstNpi" [service]="validationService"></input-errors>
              </div>
            </div>
          </div>
        </div>
        <hr>
        <h4 class="my-15">Email notifications</h4>
        <div class="d-inline-flex flex-column align-items-start">
          <div class="d-flex align-items-center gap-10 mb-15">
            <label class="form-check-label">
              <input [(ngModel)]="model.alertEnabled" formControlName="alertEnabled" class="form-check-input me-10" type="checkbox" />
              Send a notification email when the session goes offline
              <span class="icon icon-help-1 ms-0_5"
                tooltip="Please note: You will only receive a notification if the enabled session goes offline. No alerts are sent when a session is manually disabled or updated."></span>
            </label>
            <div class="d-flex justify-content-start align-items-center gap-10">
              <div class="text-primary mx-10 cp" (click)="showEmailField = !showEmailField">
                <i class="fas fa-plus me-0_5"></i> Add email
              </div>
            </div>
          </div>
          <div class="w-100">
            <div class="no-email-text text-error-r2 mb-10" *ngIf="model.alertEmails.length === 0">You need to have at least one email here. Click <a class=""
                (click)="addCurrentUserEmail()">here</a> to add yours.
            </div>
            <form [formGroup]="formEmail" class="pos-relative form">
              <div class="email-holder mb-15" *ngIf="showEmailField" @fieldAnimation>
                <input formControlName="email" type="text" class="form-control w-100" (keydown.enter)="onSubmitEmailForm($event)"
                  (blur)="onSubmitEmailForm($event)" placeholder="Type your email and press enter to add it" style="max-width: 800px" />
                <input-errors [control]="formEmail.controls.email" [service]="validationService"></input-errors>
              </div>
            </form>
          </div>
        </div>

        <div class="d-flex gap-10 mb-15">
          <div class="d-flex justify-content-start align-items-start">
            <div class="d-flex flex-wrap">
              <div class="pills-btn pills-btn-v2 email-list-item" *ngFor="let email of model.alertEmails">
                <span class="text" [title]="email">{{ email }}</span>
                <span class="icon icon-close" (click)="onUnSelectEmail(email)"></span>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="tab-pane fade" id="pills-advance" role="tabpanel" aria-labelledby="advance-tab">
        <div class="alert alert-primary mt-25">
          <b>Please note:</b> We recommend adjusting these settings only with a thorough understanding of their impact. <br>
          Our dev team is here to assist should you need guidance or have any questions.
        </div>

        <h4 class="my-15">Asynchronous processing <span class="icon icon-help-1 text-neutral-n6 ms-0_5"
            tooltip="Please keep in mind that these values will not always be the actual settings used for the SMPP session - in some cases, our SMPP session manager will modify these values in order to ensure proper functioning and performance."></span>
        </h4>

        <div class="d-flex gap-10 mb-15">
          <div class="w-100">
            <label for="window size" class="form-label">Window Size </label>
            <span class="icon icon-help-1 text-neutral-n6 ms-10"
              tooltip="The max. number of submit_sm requests that can be sent before a confirmation (submit_sm_resp) is received from the SMSC. <br>Set to 0 by default - which means our system will use synchronous processing of PDUs.<br><br>Please note that some SMSCs will not support asynchronous processing of submit_sm commands (Window Size > 1). We recommend you to only modify the default value once you have confirmed the SMSC doesn’t process the submit_sm commands synchronously.">
            </span>
            <div class="d-flex align-items-center gap-10 w-100">
              <div [ngClass]="!isWindowValueEditable ? 'w-75': 'w-100'">
                <input [(ngModel)]="model.windowSize" formControlName="windowSize" type="number" class="form-control" />
                <input-errors [control]="form.controls.windowSize" [service]="validationService"></input-errors>
              </div>
              <a class="cp" *ngIf="!isWindowValueEditable" (click)="onWindowEdit()">Edit</a>
            </div>
          </div>
          <div class="w-100">
            <label for="window wait timeout" class="form-label">Window Wait Timeout </label>
            <span class="icon icon-help-1 text-neutral-n6 ms-10"
              tooltip="The amount of time to wait until a slot opens up in the send Window. If too many submit_sm are waiting for response and the window size is full, new submit_sm requests will wait this amount of time before failing to send.">
            </span>
            <div class="d-flex align-items-center gap-10 w-100">
              <div [ngClass]="!isWindowValueEditable ? 'w-75': 'w-100'">
                <input [(ngModel)]="model.windowWaitTimeout" formControlName="windowWaitTimeout" type="number" class="form-control"
                  placeholder="in milliseconds" />
                <input-errors [control]="form.controls.windowWaitTimeout" [service]="validationService"></input-errors>
              </div>
              <a class="cp" *ngIf="!isWindowValueEditable" (click)="onWindowEdit()">Edit</a>
            </div>
          </div>
          <div class="w-100" *ngIf="isAdmin">
            <label for="Bind Timeout" class="form-label">Bind Timeout </label>
            <span class="icon icon-help-1 text-neutral-n6 ms-10"
              tooltip="Length of time to wait for a bind response. <b>Can be increased if a customer’s connections show bind timeout exceptions.</b>"></span>
            <input [(ngModel)]="model.bindTimeout" formControlName="bindTimeout" type="number" class="form-control" placeholder="in milliseconds" />
            <input-errors [control]="form.controls.bindTimeout" [service]="validationService"></input-errors>
          </div>
          <div class="w-100" *ngIf="isAdmin">
            <label for="Connect Timeout" class="form-label">Connect Timeout </label>
            <span class="icon icon-help-1 text-neutral-n6 ms-10"
              tooltip="Max time to wait for the TCP connection to establish (before bind). <b>Can be increased if a customer shows connection timeout exceptions.</b>">
            </span>
            <input [(ngModel)]="model.connectTimeout" formControlName="connectTimeout" type="number" class="form-control" placeholder="in milliseconds" />
            <input-errors [control]="form.controls.connectTimeout" [service]="validationService"></input-errors>
          </div>
        </div>

        <div class="d-flex gap-10 mb-15" *ngIf="isAdmin">
          <div class="w-100">
            <label for="Interface Version" class="form-label">Interface Version </label>
            <span class="icon icon-help-1 text-neutral-n6 ms-10"
              tooltip="Maps to SMPP bind param interface_version. Indicates the version of the SMPP protocol supported by the ESME."> </span>
            <input [(ngModel)]="model.interfaceVersion" formControlName="interfaceVersion" type="number" class="form-control" />
            <input-errors [control]="form.controls.interfaceVersion" [service]="validationService"></input-errors>
          </div>
          <div class="w-100">
            <label for="Request expiry timeout" class="form-label">Request Expiry Timeout </label>
            <span class="icon icon-help-1 text-neutral-n6 ms-10"
              tooltip="Only used if Window Size > 0. The time that our server will wait to receive a response to our submit_sm request. If the confirmation (submit_sm_resp) is not received within this time, the submission will be considered as failed.">
            </span>
            <input [(ngModel)]="model.requestExpiryTimeout" formControlName="requestExpiryTimeout" type="number" class="form-control"
              placeholder="in milliseconds" />
            <input-errors [control]="form.controls.requestExpiryTimeout" [service]="validationService"></input-errors>
          </div>
          <div class="w-100">
            <label for="Window monitor interval" class="form-label">Window Monitor Interval </label>
            <span class="icon icon-help-1 text-neutral-n6 ms-10"
              tooltip="Sets the amount of time between executions of monitoring the window for requests that expire. It's recommended that this generally either matches or is half the value of <b>requestExpiryTimeout</b>. Therefore, at worst a request would take up 1.5X the requestExpiryTimeout to clear out. <br><b>Must be greater than 0 for the requestExpiryTimeout to have any effect.</b> <br>If set too low (close to 0) it can cause heavy processor overhead in session manager.">
            </span>
            <input [(ngModel)]="model.windowMonitorInterval" formControlName="windowMonitorInterval" type="number" class="form-control"
              placeholder="in milliseconds" />
            <input-errors [control]="form.controls.windowMonitorInterval" [service]="validationService"></input-errors>
          </div>
          <div class="w-100">
            <label for="Write timeout" class="form-label">Write Timeout </label>
            <span class="icon icon-help-1 text-neutral-n6 ms-10"
              tooltip="The amount of time to wait for the netty channel to complete the write operation. By default there is no timeout set here."> </span>
            <input [(ngModel)]="model.writeTimeout" formControlName="writeTimeout" type="number" class="form-control" placeholder="in milliseconds" />
            <input-errors [control]="form.controls.writeTimeout" [service]="validationService"></input-errors>
          </div>
        </div>

        <hr *ngIf="!isAdmin">

        <div class="d-flex gap-10 mb-15">
          <!-- <div class="w-50" *ngIf="isAdmin">
                        <label for="Enable counters" class="form-label required">Enable Counters </label>
                        <span class="icon icon-help-1 text-neutral-n6 ms-10" tooltip="Enables counting of operations through the session, counters are for: txSubmitSM, txDeliverSM, txEnquireLink, txDataSM, rxSubmitSM, rxDeliverSM, rxEnquireLink, rxDataSM."> </span>
                        <div class="form-check form-switch">
                            <input type="checkbox" class="form-check-input medium" [(ngModel)]="model.enableCounters" formControlName="enableCounters" />
                        </div>
                    </div>
                    <div class="w-50" *ngIf="isAdmin">
                        <label for="Use log PDU option" class="form-label required">Use log PDU option </label>
                        <span class="icon icon-help-1 text-neutral-n6 ms-10" tooltip="Maps to Cloudhopper SessionConfiguration loggingOptions. Will either log the PDU or the raw bytes if false."> </span>
                        <div class="form-check form-switch">
                            <input type="checkbox" class="form-check-input medium" [(ngModel)]="model.useLogPduOption" formControlName="useLogPduOption" />
                        </div>
                    </div> -->
          <div class="w-25">
            <label for="tls" class="form-label required">TLS Enabled (SSL) </label>
            <span class="icon icon-help-1 text-neutral-n6 ms-10"
              tooltip="When enabled, all communication will be encrypted with TLS. Supported versions are 1.3 and 1.2. Older versions of TLS/SSL are not supported. Before enabling it, please make sure that your server supports this feature."></span>
            <div class="form-check form-switch">
              <input type="checkbox" class="form-check-input medium" [(ngModel)]="model.useSSL" formControlName="useSSL" />
            </div>
          </div>
          <div class="w-25" *ngIf="isAdmin">
            <label for="Visible All" class="form-label required">Visible All </label>
            <div class="form-check form-switch">
              <input type="checkbox" class="form-check-input medium" [(ngModel)]="model.visibleAll" formControlName="visibleAll" />
            </div>
          </div>
          <div class="w-50"></div>
        </div>

      </div>
    </div>
    <div class="step-buttons">
      <button type="button" class="btn btn-outline-dark px-20" (click)="onAfterSave.emit(null)">Cancel</button>
      <div class="d-flex w-100 justify-content-end align-items-center gap-10">
        <div class="d-flex align-items-center gap-10">
          <label for="Enabled" class="form-label mb-0">Enabled</label>
          <div class="form-check form-switch">
            <input type="checkbox" class="form-check-input medium" [(ngModel)]="model.enabled" formControlName="enabled" />
          </div>
        </div>
        <div class="v-line"></div>
        <button type="submit" class="btn btn-primary px-20" [disabled]="!isFormValid()">
          {{this.currentSessionId ? 'Save' : 'Create'}}
        </button>
      </div>
    </div>
  </form>
</div>


<ng-template #confirmWindowEditModalTpl let-dialogRef="dialogRef">
  <div class="modal-header mb-10">
    <div class="modal-title">
      <h3 class="d-inline-block">Are you sure? </h3>
      <button type="button" class="btn-close" (click)="dialogRef.close(false)">
        <span class="icon-close"></span>
      </button>
    </div>
  </div>
  <div class="modal-body">
    <p>
      Please note that some SMSCs will not support asynchronous processing of submit_sm commands (Window Size >
      1). We recommend you to only modify the default value once you have confirmed that your SMSC doesn’t process
      the submit_sm commands synchronously.
    </p>
  </div>
  <div class="modal-footer pt-15">
    <div class="button-holder d-flex justify-content-between">
      <button class="btn btn-outline-dark" (click)="dialogRef.close(false)">Cancel</button>
      <button class="btn btn-primary ms-15" (click)="dialogRef.close(true)">Confirm</button>
    </div>
  </div>
</ng-template>
